module.exports = __webpack_public_path__ + "static/media/rectangle.4f1ac081.svg";